/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Hourglass = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M20 1V2.5H18V6.4144C18 8.03613 17.2135 9.55713 15.8901 10.4945L13.2 12.4L16 14.5C17.259 15.4443 18 16.9262 18 18.5V21.5H20V23H4V21.5H6V18.5C6 17.009 6.66503 15.6005 7.80554 14.6535L8 14.5L10.8 12.4L8.10991 10.4945C6.78654 9.55713 6 8.03613 6 6.4144V2.5H4V1H20ZM12 13.375L8.9 15.7L8.72862 15.8371C8.07913 16.391 7.65682 17.1615 7.53585 18.0001L14 18V19.5H7.5V21.5H16.5V18.5L16.4931 18.2806C16.4292 17.2617 15.9226 16.3169 15.1 15.7L12 13.375ZM16.5 2.5H7.5V6H14V7.5L7.67297 7.50118C7.88201 8.14096 8.27335 8.71348 8.80769 9.14275L8.97694 9.27048L11.999 11.411L15.0231 9.27048C15.8915 8.65532 16.4297 7.6811 16.4936 6.62634L16.5 6.4144V2.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
